import * as React from "react";

const withMouseScrollHOC =
  <OriginalProps extends {}>(
    Cmp: React.ComponentType<OriginalProps>,
    getScrollEl?: (cmp: any) => HTMLElement
  ): React.FunctionComponent<OriginalProps> =>
  (props: OriginalProps) => {
    const ref = React.useRef<HTMLElement>(null);

    React.useEffect(() => {
      if (!ref.current) return;

      let isLeftButtonPressed = false;
      let scrollLeft = 0;
      let scrollTop = 0;
      let x = 0;
      let y = 0;

      let el = getScrollEl ? getScrollEl(ref.current) : ref.current;
      if (!el) return;

      el.draggable = false;
      el.classList.add("cursor_grab");

      const onMouseDown = (e: MouseEvent) => {
        if (e.buttons !== 1 || (e.target as HTMLElement).closest(".element")) return;

        isLeftButtonPressed = true;

        el.classList.add("cursor_grabbing");

        scrollLeft = el.scrollLeft;
        scrollTop = el.scrollTop;
        x = e.clientX;
        y = e.clientY;
      };

      const onMouseLeave = (e: MouseEvent) => {
        isLeftButtonPressed = false;
      };

      const onMouseMove = (e: MouseEvent) => {
        if (isLeftButtonPressed) {
          el.scrollLeft = scrollLeft + x - e.clientX;
          el.scrollTop = scrollTop + y - e.clientY;
        }
      };

      const onMouseUp = (e: MouseEvent) => {
        isLeftButtonPressed = false;

        el.classList.remove("cursor_grabbing");
      };

      el.addEventListener("mousedown", onMouseDown);
      el.addEventListener("mouseleave", onMouseLeave);
      el.addEventListener("mousemove", onMouseMove);
      el.addEventListener("mouseup", onMouseUp);

      return () => {
        if (!ref.current) return;

        el.removeEventListener("mousedown", onMouseDown);
        el.removeEventListener("mouseleave", onMouseLeave);
        el.removeEventListener("mousemove", onMouseMove);
        el.removeEventListener("mouseup", onMouseUp);
      };
    }, [ref.current]);

    return <Cmp {...props} ref={ref} />;
  };

export default withMouseScrollHOC;
